module.exports = __webpack_public_path__ + "img/sotd.881a57a1.png";